import { useEffect, useState } from 'react';

const useAwarnessBarVisibility = (isScrollStyle: boolean, selector = '.top-sticky-banner') => {
  const [isAwarnessBarVisible, setIsAwarnessBarVisible] = useState(false);

  useEffect(() => {
    const topStickyBanner = document.querySelector(selector);

    if (topStickyBanner && isScrollStyle) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsAwarnessBarVisible((prev) => prev !== entry.isIntersecting && entry.isIntersecting);
        },
        { threshold: 0 }
      );

      observer.observe(topStickyBanner);

      return () => observer.disconnect();
    }
  }, [isScrollStyle, selector]);

  return isAwarnessBarVisible;
};

export default useAwarnessBarVisibility;
